export default __webpack_public_path__ + "static/media/Niico-bg.e82d866c.svg";